import React from 'react';
import styled from 'styled-components';

const StyledLink = styled.a`
  width: 100%;
  height: 100%;
`;

const BannerImageContainer = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;

interface BannerImageProps {
  name: string;
  imageUrl: string;
  actionUrl?: string;
}

const BannerImage: React.FC<BannerImageProps> = ({
  name,
  imageUrl,
  actionUrl,
}: BannerImageProps) => (
  actionUrl ? (
    <StyledLink href={actionUrl} target="_blank" rel="noopener noreferrer" key={`banner-${imageUrl}`}>
      <BannerImageContainer
        src={imageUrl}
        alt={`${name} Banner`}
        data-object-fit="contain"
        data-object-position="center"
      />
    </StyledLink>
  ) : (
    <BannerImageContainer
      key={`banner-${imageUrl}`}
      src={imageUrl}
      alt={`${name} Banner`}
      data-object-fit="contain"
      data-object-position="center"
    />
  )
);

export default BannerImage;
